function filterRegions(callback) {
  let regions = this.regions();
  if (!callback || typeof callback !== 'function') return regions;
  return regions.filter(callback);
}

export default filterRegions;


// WEBPACK FOOTER //
// ../node_modules/daisy-chart/src/layouts/default/filterRegions.js